// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var Extauth2ProfileUpdateStatus;
(function (Extauth2ProfileUpdateStatus) {
    Extauth2ProfileUpdateStatus[Extauth2ProfileUpdateStatus["Success"] = 0] = "Success";
    Extauth2ProfileUpdateStatus[Extauth2ProfileUpdateStatus["Failed"] = 1] = "Failed";
})(Extauth2ProfileUpdateStatus || (Extauth2ProfileUpdateStatus = {}));
//# sourceMappingURL=extauth2ProfileUpdateStatus.js.map